export default "__VITE_ASSET__BGe4ca4W__"